function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloud = function SvgCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 1.333 1.333"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1.333v1.333H0z",
    style: {
      fill: "#25b7d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.835.67h.187c.013 0 .024.01.024.024v.333c0 .014-.01.025-.024.025H.835a.024.024 0 0 1-.025-.025V.694C.81.681.821.67.835.67",
    style: {
      fill: "#3e3e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.825.793h.207v.024H.825zM.825.85h.207v.024H.825zM.825.906h.207V.93H.825zM.825.962h.207v.025H.825z",
    style: {
      fill: "#7e7f80"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.9,
    cy: 0.721,
    r: 0.018,
    style: {
      fill: "#facb1b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.95,
    cy: 0.721,
    r: 0.018,
    style: {
      fill: "#f99134"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 0.721,
    r: 0.018,
    style: {
      fill: "#fa5655"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.311.67H.5c.013 0 .024.01.024.024v.333c0 .014-.01.025-.024.025H.31a.024.024 0 0 1-.024-.025V.694C.287.681.297.67.311.67",
    style: {
      fill: "#3e3e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.302.793h.206v.024H.302zM.302.85h.206v.024H.302zM.302.906h.206V.93H.302zM.302.962h.206v.025H.302z",
    style: {
      fill: "#7e7f80"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.377,
    cy: 0.721,
    r: 0.018,
    style: {
      fill: "#facb1b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.427,
    cy: 0.721,
    r: 0.018,
    style: {
      fill: "#f99134"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.476,
    cy: 0.721,
    r: 0.018,
    style: {
      fill: "#fa5655"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.573.67H.76Q.783.67.785.694v.333c0 .014-.011.025-.025.025H.573a.024.024 0 0 1-.024-.025V.694C.549.681.559.67.573.67",
    style: {
      fill: "#3e3e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.563.793H.77v.024H.563zM.563.85H.77v.024H.563zM.563.906H.77V.93H.563zM.563.962H.77v.025H.563z",
    style: {
      fill: "#7e7f80"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.638,
    cy: 0.721,
    r: 0.018,
    style: {
      fill: "#facb1b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.688,
    cy: 0.721,
    r: 0.018,
    style: {
      fill: "#f99134"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.738,
    cy: 0.721,
    r: 0.018,
    style: {
      fill: "#fa5655"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.7.282a.15.15 0 0 0-.135.084L.55.365a.074.074 0 0 0-.075.064A.095.095 0 0 0 .41.52a.094.094 0 0 0 .105.095h.28A.11.11 0 0 0 .887.58.12.12 0 0 0 .841.385.144.144 0 0 0 .7.282",
    style: {
      fill: "#f9f9f9"
    }
  }));
};
export default SvgCloud;